export * from './user-register-node.resolve';